import type { PluginFunction } from '@kastjs/runtime-core';
import { addShare, modifyMenuData } from './utils';
import { init, tangramParser } from './parser';
import { ILcdpOptions } from './types';
import LcdpComponent, { LcdpComponentProps } from './components/lcdp-render-component';
import { Env } from './enum';

const startLCDP: PluginFunction<ILcdpOptions> = async (context, options?) => {
  if (!options) return context;

  // 延后初始化
  await init();

  const { env = Env.TEST, sharedModules } = options;

  if (sharedModules) {
    addShare(sharedModules);
  }

  await modifyMenuData(context, env);
  return context;
};

export default startLCDP;
export { LcdpComponent, tangramParser, Env };

export type { ILcdpOptions, LcdpExtension } from './types';
export type { LcdpComponentProps };
